export const dummydata: any = {
   hero_h1: "Integrate Next.JS seamlessly",
   hero_description:
      "Zesty.io is the open-source, flexible API headless CMS to integrate with NextJS. Start your next project with just one line of code.",
   cta_primary_text: null,
   cta_secondary_text: null,
   integration_benefits_h2: "Zesty and Next: A Powerful Combination",
   integration_benefits: null,
   feature_description_1: "",
   feature_description_2: null,
   feature_description_3:
      '<p dir="ltr">The benefits extend to your marketing team as well:</p>\n<ul>\n<li dir="ltr" style="list-style-type: disc;" aria-level="1">\n<p dir="ltr" role="presentation">Marketers can fully control SEO components including the URL path without affecting the developer workflow</p>\n</li>\n<li dir="ltr" style="list-style-type: disc;" aria-level="1">\n<p dir="ltr" role="presentation">Leveraging NextJS server-side rendering means marketers gain a live preview for stage and development environments</p>\n</li>\n<li dir="ltr" style="list-style-type: disc;" aria-level="1">\n<p dir="ltr" role="presentation">Leveraging NextJS server-side rendering also means production can be automatically updated by marketers without waiting for a build process</p>\n</li>\n<li dir="ltr" style="list-style-type: disc;" aria-level="1">\n<p dir="ltr" role="presentation">Zesty enables marketer previews inside of the content management system - this can be done using Google Cloud, AWS or Vercel</p>\n</li>\n</ul>',
   testimonial: null,
   logos_title: "Join top companies",
   logos: {
      type: "relationship",
      model: "customer_brands",
      totalItems: 5,
      data: [
         {
            customer_name: "Sony-homepage",
            customer_logo: {
               type: "images",
               totalItems: 1,
               data: [
                  {
                     type: "image",
                     zuid: "3-d959bc7-wnj9b8",
                     url:
                        "https://kfg6bckb.media.zestyio.com/Sony-homepage150x50-fullcolor.png",
                  },
               ],
            },
            homepage_sort: "1",
            background_image: null,
            customer_story_download: null,
            customer_story_short: null,
            products_in_use: null,
            customer_story_short_raw: null,
            featured: "1",
            customer_sort: "1",
            url: null,
            grey_logo: {
               type: "images",
               totalItems: 1,
               data: [
                  {
                     type: "image",
                     zuid: "3-d959bc7-0xs8gd",
                     url:
                        "https://kfg6bckb.media.zestyio.com/Sony-homepage150x50-grey.png",
                  },
               ],
            },
            white_logo: {
               type: "images",
               totalItems: 1,
               data: [
                  {
                     type: "image",
                     zuid: "3-d95a31f-485ggg",
                     url: "https://kfg6bckb.media.zestyio.com/sony-white.png",
                  },
               ],
            },
            meta: {
               type: "item",
               model_name: "customer_brands",
               model_alternate_name: "CustomerBrand",
               zuid: "7-c28c9fc9b1-st2xwm",
               createdAt: "2022-03-22 20:27:17",
               updatedAt: "2022-03-22 20:27:16",
               listed: "1",
               version: "3",
               locale: {
                  id: "1",
                  name: "English (United States)",
                  code: "en-US",
                  default: "1",
                  active: "1",
                  enabled: "1",
               },
               model: {
                  type: "model",
                  zuid: "6-0888e8-0rv8xh",
                  name: "customer_brands",
                  label: "Customers",
                  resourceURI: "https://www.zesty.io/-/instant/6-0888e8-0rv8xh.json",
               },
            },
         },
         {
            customer_name: "Rocket League-homepage",
            customer_logo: {
               type: "images",
               totalItems: 1,
               data: [
                  {
                     type: "image",
                     zuid: "3-d9ffb35-46szwl",
                     url: "https://kfg6bckb.media.zestyio.com/RL-black.H164YWM79.png",
                  },
               ],
            },
            homepage_sort: "1",
            background_image: null,
            customer_story_download: null,
            customer_story_short: null,
            products_in_use: null,
            customer_story_short_raw: null,
            featured: "1",
            customer_sort: "1",
            url: null,
            grey_logo: {
               type: "images",
               totalItems: 1,
               data: [
                  {
                     type: "image",
                     zuid: "3-d9ffb3c-k8d6js",
                     url: "https://kfg6bckb.media.zestyio.com/RL-grey.png",
                  },
               ],
            },
            white_logo: {
               type: "images",
               totalItems: 1,
               data: [
                  {
                     type: "image",
                     zuid: "3-d9ffb41-684jph",
                     url: "https://kfg6bckb.media.zestyio.com/RL-white.png",
                  },
               ],
            },
            meta: {
               type: "item",
               model_name: "customer_brands",
               model_alternate_name: "CustomerBrand",
               zuid: "7-9ce7fddc9f-bqrt2r",
               createdAt: "2022-03-30 16:45:56",
               updatedAt: "2022-03-30 16:45:55",
               listed: "1",
               version: "5",
               locale: {
                  id: "1",
                  name: "English (United States)",
                  code: "en-US",
                  default: "1",
                  active: "1",
                  enabled: "1",
               },
               model: {
                  type: "model",
                  zuid: "6-0888e8-0rv8xh",
                  name: "customer_brands",
                  label: "Customers",
                  resourceURI: "https://www.zesty.io/-/instant/6-0888e8-0rv8xh.json",
               },
            },
         },
         {
            customer_name: "Wattpad-homepage",
            customer_logo: {
               type: "images",
               totalItems: 1,
               data: [
                  {
                     type: "image",
                     zuid: "3-d959b5d-6q0prf",
                     url:
                        "https://kfg6bckb.media.zestyio.com/Wattpad-homepage150x50-fullcolor.png",
                  },
               ],
            },
            homepage_sort: "1",
            background_image: null,
            customer_story_download: null,
            customer_story_short: null,
            products_in_use: null,
            customer_story_short_raw: null,
            featured: "1",
            customer_sort: "1",
            url: null,
            grey_logo: {
               type: "images",
               totalItems: 1,
               data: [
                  {
                     type: "image",
                     zuid: "3-d959b5d-0xvjnf",
                     url:
                        "https://kfg6bckb.media.zestyio.com/Wattpad-homepage150x50-grey.png",
                  },
               ],
            },
            white_logo: {
               type: "images",
               totalItems: 1,
               data: [
                  {
                     type: "image",
                     zuid: "3-d95a442-b0kk0d",
                     url: "https://kfg6bckb.media.zestyio.com/wattpad-white.png",
                  },
               ],
            },
            meta: {
               type: "item",
               model_name: "customer_brands",
               model_alternate_name: "CustomerBrand",
               zuid: "7-dcf592b5fe-nz9r3t",
               createdAt: "2022-03-22 20:32:09",
               updatedAt: "2022-03-22 20:32:08",
               listed: "1",
               version: "3",
               locale: {
                  id: "1",
                  name: "English (United States)",
                  code: "en-US",
                  default: "1",
                  active: "1",
                  enabled: "1",
               },
               model: {
                  type: "model",
                  zuid: "6-0888e8-0rv8xh",
                  name: "customer_brands",
                  label: "Customers",
                  resourceURI: "https://www.zesty.io/-/instant/6-0888e8-0rv8xh.json",
               },
            },
         },
         {
            customer_name: "Petdesk-homepage",
            customer_logo: {
               type: "images",
               totalItems: 1,
               data: [
                  {
                     type: "image",
                     zuid: "3-d959aed-tvdkr1",
                     url:
                        "https://kfg6bckb.media.zestyio.com/Petdesk-homepage150x50-fullcolor.png",
                  },
               ],
            },
            homepage_sort: "1",
            background_image: null,
            customer_story_download: null,
            customer_story_short: null,
            products_in_use: null,
            customer_story_short_raw: null,
            featured: "1",
            customer_sort: "1",
            url: null,
            grey_logo: {
               type: "images",
               totalItems: 1,
               data: [
                  {
                     type: "image",
                     zuid: "3-d959aed-dqbvjd",
                     url:
                        "https://kfg6bckb.media.zestyio.com/Petdesk-homepage150x50-grey.png",
                  },
               ],
            },
            white_logo: null,
            meta: {
               type: "item",
               model_name: "customer_brands",
               model_alternate_name: "CustomerBrand",
               zuid: "7-9ef497ad9d-h232d8",
               createdAt: "2022-03-22 19:52:46",
               updatedAt: "2022-03-22 19:52:45",
               listed: "1",
               version: "3",
               locale: {
                  id: "1",
                  name: "English (United States)",
                  code: "en-US",
                  default: "1",
                  active: "1",
                  enabled: "1",
               },
               model: {
                  type: "model",
                  zuid: "6-0888e8-0rv8xh",
                  name: "customer_brands",
                  label: "Customers",
                  resourceURI: "https://www.zesty.io/-/instant/6-0888e8-0rv8xh.json",
               },
            },
         },
         {
            customer_name: "Acorns-homepage",
            customer_logo: {
               type: "images",
               totalItems: 1,
               data: [
                  {
                     type: "image",
                     zuid: "3-d959aa9-f62xz4",
                     url:
                        "https://kfg6bckb.media.zestyio.com/Acorns-homepage150x50-fullcolor.png",
                  },
               ],
            },
            homepage_sort: "1",
            background_image: null,
            customer_story_download: null,
            customer_story_short: null,
            products_in_use: null,
            customer_story_short_raw: null,
            featured: "1",
            customer_sort: "1",
            url: null,
            grey_logo: {
               type: "images",
               totalItems: 1,
               data: [
                  {
                     type: "image",
                     zuid: "3-d959aa9-0hm1ww",
                     url:
                        "https://kfg6bckb.media.zestyio.com/Acorns-homepage150x50-grey.png",
                  },
               ],
            },
            white_logo: {
               type: "images",
               totalItems: 1,
               data: [
                  {
                     type: "image",
                     zuid: "3-d95a49c-6ks7n7",
                     url: "https://kfg6bckb.media.zestyio.com/acorns-white.png",
                  },
               ],
            },
            meta: {
               type: "item",
               model_name: "customer_brands",
               model_alternate_name: "CustomerBrand",
               zuid: "7-e2a8fcd0d0-pr31xg",
               createdAt: "2022-03-22 20:33:36",
               updatedAt: "2022-03-22 20:33:36",
               listed: "1",
               version: "3",
               locale: {
                  id: "1",
                  name: "English (United States)",
                  code: "en-US",
                  default: "1",
                  active: "1",
                  enabled: "1",
               },
               model: {
                  type: "model",
                  zuid: "6-0888e8-0rv8xh",
                  name: "customer_brands",
                  label: "Customers",
                  resourceURI: "https://www.zesty.io/-/instant/6-0888e8-0rv8xh.json",
               },
            },
         },
      ],
   },
   meta: {
      type: "item",
      model_name: "integrations_individual_pages",
      model_alternate_name: "IntegrationsIndividualPage",
      zuid: "7-d48acf90e9-pchhtq",
      createdAt: "2022-04-06 17:43:27",
      updatedAt: "2022-04-06 17:43:27",
      listed: "1",
      version: "2",
      locale: {
         id: "1",
         name: "English (United States)",
         code: "en-US",
         default: "1",
         active: "1",
         enabled: "1",
      },
      model: {
         type: "model",
         zuid: "6-88e5918e85-tmg13p",
         name: "integrations_individual_pages",
         label: "Integrations-Individual Pages",
         resourceURI: "https://www.zesty.io/-/instant/6-88e5918e85-tmg13p.json",
      },
      web: {
         url: "https://www.zesty.io/integrations/nextjs-cms/",
         uri: "/integrations/nextjs-cms/",
         fragment: "nextjs-cms",
         canonical_tag_mode: "1",
         sitemap_priority: "-1.0",
         sitemap_last_updated: "2022-04-06 17:43:27",
         canonical_query_param_whitelist: null,
         canonical_tag_custom_value: null,
         seo_link_text: "Integrate Next.JS seamlessly",
         seo_meta_title: "Integrate Next.JS seamlessly",
         seo_meta_description: "",
         seo_meta_keywords: null,
      },
   },
   zestyProductionMode: true,
   zestyInstanceZUID: "8-aaeffee09b-7w6v22",
   zestyBaseURL: "https://www.zesty.io",
}
